import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Alert
} from '@mui/material';
import { Security as SecurityIcon, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Redirect to main web app
    window.location.href = '/';
  };

  const handleGoToAuth = () => {
    navigate('/admin/auth');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={3}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <SecurityIcon 
              sx={{ 
                fontSize: 64, 
                color: 'error.main', 
                mb: 2 
              }} 
            />
            
            <Typography variant="h4" component="h1" gutterBottom color="error">
              Access Denied
            </Typography>
            
            <Alert severity="error" sx={{ mb: 3 }}>
              You don't have admin privileges to access this area.
            </Alert>
            
            <Typography variant="body1" color="text.secondary" paragraph>
              The admin panel is restricted to users with administrator privileges. 
              If you're a patient or caregiver, please use the main ShareGiver application instead.
              Contact your system administrator if you believe you should have admin access.
            </Typography>
            
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                startIcon={<HomeIcon />}
                onClick={handleGoHome}
                sx={{ minWidth: 120 }}
              >
                Main App
              </Button>
              
              <Button
                variant="contained"
                onClick={handleGoToAuth}
                sx={{ minWidth: 120 }}
              >
                Try Again
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
